import { Box, CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import React, { useEffect } from "react";
import { AiOutlineRight } from "react-icons/ai";
// import TopFlexRow from "../TopFlexRow/TopFlexRow";
import { useHistory } from "react-router-dom";
import { fetchHistoricData } from "../../../redux/actions";
import heroImage from "../../../assets/staticAssets/hero_image_2.png";
import Tilt from "react-tilt";
import loadable from "@loadable/component";

const TopFlexRow = loadable(() => import("../TopFlexRow/TopFlexRow"), {
  fallback: (
    <div className="w-screen h-[120px] flex items-center justify-center">
      <CircularProgress color="primary" />
    </div>
  ),
});

function LandingPageHeaderTwo() {
  const classes = useStyles();
  const history = useHistory();

  return (
    <>
      <Box
        // style={{ height: "calc(100vh - 120px)" }}
        className="flex flex-col justify-center "
      >
        <div>
          <div className="flex items-center md:pt-20 md:px-14 pt-24 px-10 justify-between flex-wrap md:flex-nowrap ">
            <div className="md:w-[50%] mb-5 md:mb-0">
              <h1 className="md:text-[56px] text-[36px] mb-2">
                Instant & Easy
              </h1>
              <span className="" style={{ color: "#ccc" }}>
                <h2 className="leading-loose font-light text-[16px] md:text-[23px] ">
                  Buy and Sell 100+ Crypto Assets in INR. <br></br>{" "}
                  <span className="text-pb-primary-100 font-semibold ">
                    0% fees
                  </span>{" "}
                  and{" "}
                  <span className="text-pb-primary-100 font-semibold ">
                    Infinite
                  </span>{" "}
                  liquidity.
                </h2>
              </span>
              <div
                className="flex items-center gap-x-2 bg-pb-primary-100 py-4 px-4 rounded-lg text-white w-max font-bold hover:bg-opacity-50 transition-all cursor-pointer mt-5"
                onClick={() => {
                  history.push("/createacc");
                }}
              >
                {" "}
                <img
                  src={
                    require("../../../assets/optimized/Landing/Hero Section/Navbar Icons/signIn-icon.svg")
                      .default
                  }
                ></img>
                GET STARTED
              </div>
            </div>
            <div className=" flex md:w-[50%]">
              <Tilt className="Tilt" options={{ max: 15 }}>
                <img
                  className="w-full "
                  src={heroImage}
                  alt="pocketbits"
                  style={{ maxWidth: "70vh" }}
                ></img>
              </Tilt>
            </div>
          </div>
        </div>

        <div className="mt-44 ">
          <TopFlexRow />
        </div>
      </Box>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  linkHolder: {
    // position: "absolute",
    display: "flex",
    // marginRight: "30px",
    margin: "20px 30px",
    alignItems: "center",
    justifyContent: "center",
    top: "10%",
    // transform: "translateY(70px)",
  },
  logo: {
    marginLeft: "10px",
  },
  marketLink: {
    color: "#fff",
    textDecoration: "none",
    borderBottom: "1px solid #fff",
    paddingBottom: "5px",
    "&:hover": {
      cursor: "pointer",
    },
  },
}));

export default LandingPageHeaderTwo;
